import { createSelector } from '@reduxjs/toolkit';

import type { IStore } from 'old-store/types';

export const selectImages = (state: IStore) => state.images.images;
const selectEndCustomer = (state: IStore) => state.endCustomer;

const selectImagesById = createSelector(
  selectImages,
  (images) => new Map(images.map((image) => [image._id, image]))
);

// O(1) per-tile lookup instead of `images.find` in every tile
export const selectImageById = (state: IStore, imageId: string) =>
  selectImagesById(state).get(imageId);

export const selectAllImagesExceptGifs = createSelector(selectImages, (images) =>
  images.filter((image) => image.extension.toLowerCase() !== 'gif')
);

export const selectHasHiddenImages = createSelector(
  selectImages,
  selectEndCustomer,
  (images, endCustomer) => {
    const hiddenImages = images.filter((image) => image.hiddenBy.includes(endCustomer._id));

    return hiddenImages.length > 0;
  }
);
